import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsPopUpWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/modules/StorefrontValues/models/RewardsStorefrontValuesEntities";
import { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import type { Observable } from "rxjs";
import { take, tap } from "rxjs";

interface RewardsPopUpWidgetInjectorConfig extends RewardsWidgetInjectorConfig {
    branding$: Observable<RewardsStorefrontValuesBrandingEntity>;
}

class RewardsPopUpWidgetInjector {
    constructor(private readonly config: RewardsPopUpWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug("RewardsPopUpWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });
        const widgetName = REWARDS_WIDGET_NAMES.REWARDS_POP_UP_WIDGET;

        this.config.branding$
            .pipe(
                take(1),
                tap((branding) => {
                    const targets$ =
                        this.config.mutationObserverInjector.register({
                            targetSelector: `${this.config.placeholderSelector}-${branding.popUpWidget.launcher.position.placement}`,
                        });

                    targets$.subscribe((placeholder) => {
                        this.config.logger.debug(
                            "RewardsPopUpWidgetInjector found placeholder",
                            {
                                placeholder,
                            }
                        );

                        void (async () => {
                            const RewardsPopUpWidget =
                                await this.config.dynamicImportManager.importDefault(
                                    RewardsPopUpWidgetDefinition,
                                    true
                                );

                            const widget = new RewardsPopUpWidget(
                                {
                                    target: placeholder,
                                },
                                this.config.logger
                            );

                            await widget.init();

                            this.config.eventsCollector.pushEvent(
                                this.config.eventsFactory.createWidgetInjected(
                                    widgetName
                                )
                            );

                            dispatchSdkEvent(
                                new WidgetInjectedSdkEvent(widgetName)
                            );
                        })();
                    });
                })
            )
            .subscribe();
    }
}

export default RewardsPopUpWidgetInjector;
